// extracted by mini-css-extract-plugin
export default {"sparks":"TournamentSparks_sparks__yNF2g","spark":"TournamentSparks_spark__q3YDi","tournamentFloat":"TournamentSparks_tournamentFloat__c25bx"};